import type { MarketExceptionType } from '@/constants/MarketExceptions/MarketExceptionTypes'

const DEFAULT_RTL_LANGUAGES = ['ar', 'he', 'fa', 'ur'] as const

export const isRtlLanguage = (
  language: string,
  marketConfig?: MarketExceptionType,
): boolean => {
  if (marketConfig?.rtlLanguages?.enabled === false) {
    return false
  }

  if (
    marketConfig?.rtlLanguages?.enabled &&
    marketConfig?.rtlLanguages?.supportedLanguages
  ) {
    return marketConfig.rtlLanguages.supportedLanguages.includes(language)
  }

  const isActuallyRtl = DEFAULT_RTL_LANGUAGES.includes(
    language as (typeof DEFAULT_RTL_LANGUAGES)[number],
  )
  return isActuallyRtl
}

export const getTextDirection = (
  language: string,
  marketConfig?: MarketExceptionType,
): 'ltr' | 'rtl' => (isRtlLanguage(language, marketConfig) ? 'rtl' : 'ltr')

export const shouldUseGlobalTextAlign = (
  language: string,
  marketConfig?: MarketExceptionType,
): boolean => {
  if (!isRtlLanguage(language, marketConfig)) {
    return false
  }

  return marketConfig?.rtlLanguages?.enableGlobalTextAlign ?? true
}
